export default function ImagePreview({ src, name, kind }) {
  return (
    <div className="image-preview">
      <img src={src} alt={name || "图片预览"} />
      <div className="image-kind">
        {kind === "image" ? "图片编辑模式" : "图片预览"}
      </div>
    </div>
  );
}
